import type { ClientEnvironment } from "@/features/clientEnv";
import { isOfficialApkUserAgent } from "../../clientEnv/ua";
import type {
  WithdrawalOfficialAppPromptOutcome,
  WithdrawalOfficialAppPromptStage,
} from "./types";

export const WITHDRAWAL_OFFICIAL_APP_PROMPT_STAGE:
  WithdrawalOfficialAppPromptStage = "enter_withdraw";

interface WithdrawalOfficialAppPromptEligibilityInput {
  env: ClientEnvironment;
  installLink: string;
  isSnoozed: boolean;
  requestedStage: WithdrawalOfficialAppPromptStage;
  configuredStage?: WithdrawalOfficialAppPromptStage;
}

export const isOfficialApkEnvironment = (env: ClientEnvironment): boolean =>
  env.isNativeWebView || isOfficialApkUserAgent(env.ua.ua);

export const shouldShowWithdrawalOfficialAppPrompt = ({
  env,
  installLink,
  isSnoozed,
  requestedStage,
  configuredStage = WITHDRAWAL_OFFICIAL_APP_PROMPT_STAGE,
}: WithdrawalOfficialAppPromptEligibilityInput): boolean =>
  configuredStage === requestedStage &&
  !isOfficialApkEnvironment(env) &&
  Boolean(installLink) &&
  !isSnoozed;

export const shouldContinueWithdrawalAfterPrompt = (
  stage: WithdrawalOfficialAppPromptStage,
  outcome: WithdrawalOfficialAppPromptOutcome,
): boolean => stage === "enter_withdraw" || outcome === "continue";
